import React from 'react';
import { useBooleanFlag } from 'utils/flags';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import OldCreateInvoice from './oldCreateInvoice';
import NewCreateInvoice from './newCreateInvoice';

export default function CreateInvoice() {
  const enableNewCreateInvoice = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_NEW_CREATE_INVOICE_SCREEN
  );
  if (enableNewCreateInvoice) {
    return <NewCreateInvoice />;
  }
  return <OldCreateInvoice />;
}
